import { Type } from 'class-transformer';
import { Observable } from 'rxjs';

import { Media } from '@eiq/files/models';

import { AIPromptCore } from './ai-prompt.model';
import { BlockModel } from './block.model';
import { IFollowUp } from './followup-up.interface';
import { PageModel } from './page.model';
import { AllowedForQuotasQuestionTypes } from './question-type.enum';
import { Question } from './question.model';
import { Source } from './source.model';
import { SurveyBase } from './survey-base.model';
import { SurveyLocalization } from './survey-localization.model';
import { SurveySettings } from './survey-settings.model';

export class SurveyModel extends SurveyBase {
  @Type(() => Media)
  welcomeStimulus: Media[];

  @Type(() => PageModel)
  pages: PageModel[];

  @Type(() => BlockModel)
  blocks: BlockModel[];

  @Type(() => Question)
  questionsHidden: Question[];

  @Type(() => Source)
  sources: Source[];

  endPageHtml: string;
  endButtonText: string;
  inviteId: string;
  programmerNotes: string;
  settings: SurveySettings;
  showTitleInd: boolean;
  useEndPageInd: boolean;
  welcomeHtml: string;
  loc: SurveyLocalization[];

  aiFollowupCall: (prompt: AIPromptCore) => Observable<IFollowUp>;

  get questions(): Question[] {
    return this.pages.reduce((questions, page) => (questions = [...questions, ...page.questions]), []);
  }

  get questionsAndVariablesForReports(): Question[] {
    let sourcesQuestions: Question[] = [];
    if (this.sources) {
      sourcesQuestions = this.sources.flatMap((s) => s.variables).filter((q) => q.variableRequiredType !== 'UNIQUE');
    }
    return [...sourcesQuestions, ...this.questions, ...this.questionsHidden];
  }

  get questionsAndVariablesForQuotas(): Question[] {
    let sourcesQuestions: Question[] = [];
    if (this.sources) {
      sourcesQuestions = this.sources
        .flatMap((s) => s.variables)
        .filter((q) => q.variableRequiredType !== 'UNIQUE' && AllowedForQuotasQuestionTypes.includes(q.type));
    }
    return [...sourcesQuestions, ...this.questions.filter((q) => AllowedForQuotasQuestionTypes.includes(q.type)), ...this.questionsHidden];
  }

  get renderTitle(): boolean {
    return this.title?.length > 0 && this.showTitleInd;
  }

  get editableSources(): Source[] {
    return this.sources?.filter((source) => !source.isSystem) ?? [];
  }
}
